module.exports = __webpack_public_path__ + "img/success.1738a435.png";